module.exports = __webpack_public_path__ + "static/cardstructure-masonry-e1bf05adf6867826169c2fa992033349.png";